import bus from './bus'
import moment from 'moment'

// ToDo noch nicht in exterener Datei common/memo.conf.js
export const MemoConf = {
  TYP: {
    0: {
      OPTION: {VALUE: 0, TEXT: 'Vorgabe'},
      SYMBOL: {CLASS: 'fa-exclamation', TITLE: 'Vorgabe'},
	},
    1: {
      OPTION: {VALUE: 1, TEXT: 'Info'},
      SYMBOL: {CLASS: 'fa-info-circle', TITLE: 'Info'},
	},
    2: {
      OPTION: {VALUE: 2, TEXT: 'Intern'},
      SYMBOL: {CLASS: 'fa-home', TITLE: 'Interne Anweisung'},
	},
}
};

export const MemoView = {
  TYP: {
    0: {
      OPTION: {VALUE: '', TEXT: 'automatisch'},
	},
    1: {
      OPTION: {VALUE: 'v', TEXT: 'öffnen'},
	},
    2: {
      OPTION: {VALUE: 'h', TEXT: 'geschlossen'},
	},
}
};


export default {
  
  data () {
    return {
      
      editModus: false,
      MemoConf: MemoConf,
      MemoView: MemoView,

    }
  },
  
  props: {
    data_parent: null,
    collapseIn: false,
    idCompany:  null,
    idUser: null,
    memo: {
      type: Object,
      default:  function () {
        return {
          briefing:"",
          id:"",
          datetimeUpdate:"0000-00-00 00:00:00",
          datetimeRegister:"0000-00-00 00:00:00",
          headline:"",
          view:"",
          datetimeEnd:"2029-12-31 00:00:00",
          datetimeBegin: moment().format('YYYY-MM-DD HH:mm:ss'),
          editor:"",
          idCompany: this.idCompany,
          idParent:"",
          idUserClient: this.idUser,
          //userClientRef:[],
          sorting:"0",
          summary:"",
          text:"",
          typ:"0",
        };
      },
    }
  },
      
  created: function () {},

  computed: {},
  
  methods: {
    
    save: function (memo) {
      if(!memo.id){
        this.insert(memo);
      }else{
        this.update(memo);
      }
    },
    
    insert: function (memo) {
      this.$http.post(bus.config.path + '/memo/' + bus.call.idCompanyClient , memo).then((response) => {
        memo = response.data;
        this.onInsert(memo);
      }, (response) => {
        // error callback
      });
      this.editModus = false;
    },
      
    update: function (memo) {
      this.$http.put(bus.config.path + '/memo/' + bus.call.idCompanyClient + '/'  + memo.id , memo).then((response) => {
        memo = response.data;
          this.onUpdate(memo);
      }, (response) => {
          // error callback
      });
      this.editModus = false;
    },
      
    cancel: function (memo) {
      this.onCancel(memo);
      this.editModus = false;
    },

    remove: function (memo) {
      this.$http.delete(bus.config.path + '/memo/' + bus.call.idCompanyClient + '/' + memo.id ).then((response) => {
        this.onRemove(memo);
      }, (response) => {
        // error callback
      });
      this.editModus = false;
    },
    
    onInsert: function (memo) {
      // DO nothing her. Override this Method if necessary
    },
  
    onUpdate: function (memo) {
      // DO nothing her. Override this Method if necessary
    },
  
    onCancel: function (memo) {
      // DO nothing her. Override this Method if necessary
    },
  
    onRemove: function (memo) {
      // DO nothing her. Override this Method if necessary
    },
    

  }
  
}



// WEBPACK FOOTER //
// ./src/common/memo.common.js